import { ImmHelper } from "./Immutable";

export type NormalizedRecord<K extends PropertyKey, D> = {
  byId: Record<K, D>;
  ids: K[];
}

export class NormalizedRecordUtil {
  static createEmpty(): NormalizedRecord<any, any> {
    return {
      byId: {},
      ids: []
    }
  }

  static createOne<K extends PropertyKey, D>(id: K, item: D): NormalizedRecord<K, D> {
    const byId = {
      [id]: item
    } as Record<K, D>
    return {
      byId,
      ids: [id]
    }
  }

  static add<K extends PropertyKey, D>(old: NormalizedRecord<K, D>, id: K, item: D): NormalizedRecord<K, D> {
    const byId = {
      ...old?.byId,
      [id]: item
    } as Record<K, D>;
    return {
      byId,
      ids: Object.keys(byId) as K[]
    }
  }

  static delete<K extends PropertyKey, D>(old: NormalizedRecord<K, D>, id: K): NormalizedRecord<K, D> {
    const byId = ImmHelper.deleteProperty(old.byId, id) as Record<K, D>;
    return {
      byId,
      ids: Object.keys(byId) as K[]
    }
  }
}